function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ENGLISH_EXAM_INPUT_V, _ENGLISH_EXAM_TYPE_VA, _ENGLISH_EXAM_TYPE_VA2, _ENGLISH_EXAM_TYPE_VA4, _SCORE_LIMITS;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
export var ENGLISH_EXAM_TYPE_VALUES = {
  TOEFL: 'toefl',
  IELTS: 'ielts',
  DUOLINGO: 'duolingo_english',
  PTE: 'pte',
  DONT_HAVE: '',
  PROVIDELATER: 'provide_later'
};
export var ENGLISH_EXAM_INPUT_TYPES = {
  LISTENING: 'l',
  READING: 'r',
  SPEAKING: 's',
  WRITING: 'w',
  TOTAL: 'total'
};
export var ENGLISH_EXAM_INPUT_VALUES = (_ENGLISH_EXAM_INPUT_V = {}, _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.TOEFL, new Set([ENGLISH_EXAM_INPUT_TYPES.LISTENING, ENGLISH_EXAM_INPUT_TYPES.READING, ENGLISH_EXAM_INPUT_TYPES.WRITING, ENGLISH_EXAM_INPUT_TYPES.SPEAKING])), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.IELTS, new Set([ENGLISH_EXAM_INPUT_TYPES.LISTENING, ENGLISH_EXAM_INPUT_TYPES.READING, ENGLISH_EXAM_INPUT_TYPES.WRITING, ENGLISH_EXAM_INPUT_TYPES.SPEAKING])), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.DUOLINGO, new Set([ENGLISH_EXAM_INPUT_TYPES.TOTAL])), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.PTE, new Set([ENGLISH_EXAM_INPUT_TYPES.TOTAL, ENGLISH_EXAM_INPUT_TYPES.LISTENING, ENGLISH_EXAM_INPUT_TYPES.READING, ENGLISH_EXAM_INPUT_TYPES.WRITING, ENGLISH_EXAM_INPUT_TYPES.SPEAKING])), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.DONT_HAVE, new Set()), _defineProperty(_ENGLISH_EXAM_INPUT_V, ENGLISH_EXAM_TYPE_VALUES.PROVIDELATER, new Set()), _ENGLISH_EXAM_INPUT_V);
export var SCORE_LIMITS = (_SCORE_LIMITS = {}, _defineProperty(_SCORE_LIMITS, ENGLISH_EXAM_TYPE_VALUES.TOEFL, (_ENGLISH_EXAM_TYPE_VA = {}, _defineProperty(_ENGLISH_EXAM_TYPE_VA, ENGLISH_EXAM_INPUT_TYPES.LISTENING, {
  min: 0,
  max: 30,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA, ENGLISH_EXAM_INPUT_TYPES.READING, {
  min: 0,
  max: 30,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA, ENGLISH_EXAM_INPUT_TYPES.SPEAKING, {
  min: 0,
  max: 30,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA, ENGLISH_EXAM_INPUT_TYPES.WRITING, {
  min: 0,
  max: 30,
  step: 1
}), _ENGLISH_EXAM_TYPE_VA)), _defineProperty(_SCORE_LIMITS, ENGLISH_EXAM_TYPE_VALUES.IELTS, (_ENGLISH_EXAM_TYPE_VA2 = {}, _defineProperty(_ENGLISH_EXAM_TYPE_VA2, ENGLISH_EXAM_INPUT_TYPES.LISTENING, {
  min: 1,
  max: 9,
  step: 0.5
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA2, ENGLISH_EXAM_INPUT_TYPES.READING, {
  min: 1,
  max: 9,
  step: 0.5
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA2, ENGLISH_EXAM_INPUT_TYPES.SPEAKING, {
  min: 1,
  max: 9,
  step: 0.5
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA2, ENGLISH_EXAM_INPUT_TYPES.WRITING, {
  min: 1,
  max: 9,
  step: 0.5
}), _ENGLISH_EXAM_TYPE_VA2)), _defineProperty(_SCORE_LIMITS, ENGLISH_EXAM_TYPE_VALUES.DUOLINGO, _defineProperty({}, ENGLISH_EXAM_INPUT_TYPES.TOTAL, {
  min: 10,
  max: 160,
  step: 5
})), _defineProperty(_SCORE_LIMITS, ENGLISH_EXAM_TYPE_VALUES.PTE, (_ENGLISH_EXAM_TYPE_VA4 = {}, _defineProperty(_ENGLISH_EXAM_TYPE_VA4, ENGLISH_EXAM_INPUT_TYPES.LISTENING, {
  min: 10,
  max: 90,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA4, ENGLISH_EXAM_INPUT_TYPES.READING, {
  min: 10,
  max: 90,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA4, ENGLISH_EXAM_INPUT_TYPES.SPEAKING, {
  min: 10,
  max: 90,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA4, ENGLISH_EXAM_INPUT_TYPES.WRITING, {
  min: 10,
  max: 90,
  step: 1
}), _defineProperty(_ENGLISH_EXAM_TYPE_VA4, ENGLISH_EXAM_INPUT_TYPES.TOTAL, {
  min: 10,
  max: 90,
  step: 1
}), _ENGLISH_EXAM_TYPE_VA4)), _SCORE_LIMITS);